export const center_app_version = {"commit_sha": "c2883329"}
